export enum FORM_ACTION {
  ERROR = 'Error',
  SUBMIT = 'Submit',
  SUCCESS = 'Success',
  FAILURE = 'Failure',
}

export enum LOCAL_STORAGE {
  IS_LEAD_SUBMITTED = 'isLeadSubmitted',
  IS_REGISTERED_FOR_WEBINARS = 'isRegistered',
}
